import { render, staticRenderFns } from "./CbsTextarea.vue?vue&type=template&id=f0598774&"
import script from "./CbsTextarea.vue?vue&type=script&lang=js&"
export * from "./CbsTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports